import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Church is in Session',
  date: new Date(2023, 2, 19),
  img: '/img/church-choir.jpeg',
  tracks: [
    {
      title: 'Chicken',
      src: '/songs/2023-03-19/chicken.mp3',
    },
    {
      title: 'Chicka Boop',
      src: '/songs/2023-03-19/chicka_boop.mp3',
    },
    {
      title: 'Savage',
      src: '/songs/2023-03-19/savage.mp3',
    },
    {
      title: 'Freedom',
      src: '/songs/2023-03-19/freedom.mp3',
    },
    {
      title: 'You at Church, Bitch',
      src: '/songs/2023-03-19/you_at_church.mp3',
    },
    {
      title: 'Beepaneeno',
      src: '/songs/2023-03-19/beepaneeno.mp3',
    },
    {
      title: 'Neutral Eyes',
      src: '/songs/2023-03-19/neutral_eyes.mp3',
    },
    {
      title: 'Rodger That',
      src: '/songs/2023-03-19/rodger_that.mp3',
    },
    {
      title: 'Bones',
      src: '/songs/2023-03-19/bones.mp3',
    },
    {
      title: 'Plans',
      src: '/songs/2023-03-19/plans.mp3',
    },
    {
      title: 'Six Eight',
      src: '/songs/2023-03-19/six_eight.mp3',
    },
    {
      title: 'Candy',
      src: '/songs/2023-03-19/candy.mp3',
    },
  ]
}
export default album;